import { IPublicOfficeResourceshort } from '../../props/users/office';
import Request from './../request';

const OfficeService = {
  retrieve: async (qs?: string): Promise<IPublicOfficeResourceshort[]> => {
    try {
      const results = await Request.get(`/api/offices?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  get: async (id: string): Promise<IPublicOfficeResourceshort> => {
    try {
      const results = await Request.get(`/api/offices/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  new: async (data: FormData): Promise<IPublicOfficeResourceshort> => {
    try {
      const result = await Request.post(`/api/offices`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  update: async (id: string, data: FormData): Promise<IPublicOfficeResourceshort> => {
    try {
      const result = await Request.post(`/api/offices/${id}?_method=PUT`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<void> => {
    try {
      await Request.delete(`/api/offices/${id}`);
      return;
    } catch (e) {
      throw e;
    }
  },
};

export default OfficeService;
